export const BASE_URL = "https://rcms.mogasoft.com";
// export const BASE_URL = "http://localhost:8000";



// ============================================================================
export const APILogInIfo = BASE_URL + "/api/login-info";

// Settings Users
export const APIUserStore = BASE_URL+"/api/user/store";
export const APIUserList = BASE_URL+"/api/user/list";
export const APIUserNames = BASE_URL+"/api/user/names";
export const APIUserLogin = BASE_URL+"/api/user/login";
export const APIUserLogout = BASE_URL+"/api/user/logout";
export const APIUserUpdate = BASE_URL+"/api/user/update";
export const APIUserDelete = BASE_URL+"/api/user/delete";
export const APIUserUpdatePassword = BASE_URL+"/api/user/update/password";
export const APIUserExportExcel = BASE_URL+"/api/user/export-excel";
export const APIUserExportPDF = BASE_URL+"/api/user/export-pdf";


// Role and Permission APIs
export const APIRoleList = BASE_URL + "/api/roles";
export const APIRoleAll = BASE_URL + "/api/roles/all";
export const APIRoleShow = BASE_URL + "/api/roles/show";
export const APIRoleStore = BASE_URL + "/api/roles/store";
export const APIRoleUpdate = BASE_URL + "/api/roles/update";
export const APIRoleDelete = BASE_URL + "/api/roles/delete";
export const APIRoleAssignPermissions = BASE_URL + "/api/roles/assign-permissions";
export const APIRoleRemovePermissions = BASE_URL + "/api/roles/remove-permissions";

// Permission
export const APIPermissionList = BASE_URL + "/api/permission/list";
export const APIPermissionStore = BASE_URL + "/api/permission/store";
export const APIPermissionUpdate = BASE_URL + "/api/permission/update";
export const APIPermissionDelete = BASE_URL + "/api/permission/delete";



// Settings Branche
export const APIBranchList = BASE_URL+"/api/branche/list";
export const APIBranchNames = BASE_URL+"/api/branche/names";
export const APIBranchStore = BASE_URL+"/api/branche/store";
export const APIBranchUpdate = BASE_URL+"/api/branche/update";
export const APIBranchDelete = BASE_URL+"/api/branche/delete";
export const APIBranchNamesFilter = BASE_URL+"/api/branche/names";
export const APIBranchExportExcel = BASE_URL+"/api/branche/export-excel";
export const APIBranchExportPDF = BASE_URL+"/api/branche/export-pdf";


// Company
export const APICompanyList = BASE_URL + "/api/company/list";
export const APICompanyStore = BASE_URL + "/api/company/store";
export const APICompanyShow = BASE_URL + "/api/company/show/";
export const APICompanyUpdate = BASE_URL + "/api/company/update";
export const APICompanyDelete = BASE_URL + "/api/company/delete";
export const APICompanyNames = BASE_URL + "/api/company/names";
export const APICompanyConfig = BASE_URL + "/api/company/config";
export const APICompanyPrint = BASE_URL + "/api/company/print";
export const APICompanyExportExcel = BASE_URL+"/api/company/export-excel";
export const APICompanyExportPDF = BASE_URL+"/api/company/export-pdf";


// Dashboard APIs
export const APIDashboardStats = BASE_URL+"/api/dashboard/stats";
export const APIDashboardChartData = BASE_URL+"/api/dashboard/chart-data";
export const APIDashboardRecentActivities = BASE_URL+"/api/dashboard/recent-activities";
export const APIDashboardQuickActions = BASE_URL+"/api/dashboard/quick-actions";



// Apartment APIs
export const APIApartmentList = BASE_URL+"/api/apartment/list";
export const APIApartmentStore = BASE_URL+"/api/apartment/store";
export const APIApartmentShow = BASE_URL+"/api/apartment/show/";
export const APIApartmentUpdate = BASE_URL+"/api/apartment/update";
export const APIApartmentDelete = BASE_URL+"/api/apartment/delete";
export const APIApartmentExportExcel = BASE_URL+"/api/apartment/export-excel";
export const APIApartmentExportPDF = BASE_URL+"/api/apartment/export-pdf";
export const APIApartmentPrint = BASE_URL+"/api/apartment/print";


// Property APIs
export const APIPropertyList = BASE_URL+"/api/property/list";
export const APIPropertyStore = BASE_URL+"/api/property/store";
export const APIPropertyNames = BASE_URL+"/api/property/names";
export const APIPropertyShow = BASE_URL+"/api/property/show/";
export const APIPropertyUpdate = BASE_URL+"/api/property/update";
export const APIPropertyDelete = BASE_URL+"/api/property/delete";
export const APIPropertyExportExcel = BASE_URL+"/api/property/export-excel";
export const APIPropertyExportPDF = BASE_URL+"/api/property/export-pdf";
export const APIPropertyPrint = BASE_URL+"/api/property/print";
export const APIPropertyStats = BASE_URL+"/api/property/stats";

// Floor Unit APIs
export const APIFloorUnitList = BASE_URL+"/api/floor-unit/list";
export const APIFloorUnitStore = BASE_URL+"/api/floor-unit/store";
export const APIFloorUnitShow = BASE_URL+"/api/floor-unit/show/";
export const APIFloorUnitUpdate = BASE_URL+"/api/floor-unit/update";
export const APIFloorUnitDelete = BASE_URL+"/api/floor-unit/delete";
export const APIFloorUnitExportExcel = BASE_URL+"/api/floor-unit/export-excel";
export const APIFloorUnitExportPDF = BASE_URL+"/api/floor-unit/export-pdf";
export const APIFloorUnitPrint = BASE_URL+"/api/floor-unit/print";
export const APIFloorUnitStats = BASE_URL+"/api/floor-unit/stats";
export const APIFloorUnitNames = BASE_URL+"/api/floor-unit/names";

// Tenant APIs
export const APITenantList = BASE_URL+"/api/tenant/list";
export const APITenantStore = BASE_URL+"/api/tenant/store";
export const APITenantShow = BASE_URL+"/api/tenant/show/";
export const APITenantUpdate = BASE_URL+"/api/tenant/update";
export const APITenantDelete = BASE_URL+"/api/tenant/delete";
export const APITenantExportExcel = BASE_URL+"/api/tenant/export-excel";
export const APITenantExportPDF = BASE_URL+"/api/tenant/export-pdf";
export const APITenantPrint = BASE_URL+"/api/tenant/print";
export const APITenantStats = BASE_URL+"/api/tenant/stats";
export const APITenantHistory = BASE_URL+"/api/tenant/history";
export const APITenantAssignApartment = BASE_URL+"/api/tenant/assign-apartment";
export const APITenantVacate = BASE_URL+"/api/tenant/vacate";

// Assignment APIs
export const APIAssignmentList = BASE_URL+"/api/assignment/list";
export const APIAssignmentStore = BASE_URL+"/api/assignment/store";
export const APIAssignmentShow = BASE_URL+"/api/assignment/show/";
export const APIAssignmentUpdate = BASE_URL+"/api/assignment/update";
export const APIAssignmentDelete = BASE_URL+"/api/assignment/delete";
export const APIAssignmentExportExcel = BASE_URL+"/api/assignment/export-excel";
export const APIAssignmentExportPDF = BASE_URL+"/api/assignment/export-pdf";
export const APIAssignmentPrint = BASE_URL+"/api/assignment/print";
export const APIAssignmentStats = BASE_URL+"/api/assignment/stats";
export const APIAssignmentTerminate = BASE_URL+"/api/assignment/terminate";
export const APIAssignmentComplete = BASE_URL+"/api/assignment/complete";
export const APIAssignmentHistory = BASE_URL+"/api/assignment/history";

// Payment APIs
export const APIPaymentList = BASE_URL+"/api/payment/list";
export const APIPaymentStore = BASE_URL+"/api/payment/store";
export const APIPaymentShow = BASE_URL+"/api/payment/show/";
export const APIPaymentUpdate = BASE_URL+"/api/payment/update";
export const APIPaymentDelete = BASE_URL+"/api/payment/delete";
export const APIPaymentExportExcel = BASE_URL+"/api/payment/export-excel";
export const APIPaymentExportPDF = BASE_URL+"/api/payment/export-pdf";
export const APIPaymentPrint = BASE_URL+"/api/payment/print";
export const APIPaymentStats = BASE_URL+"/api/payment/stats";
export const APIPaymentReceipt = BASE_URL+"/api/payment/receipt";
export const APIPaymentVerify = BASE_URL+"/api/payment/verify";
export const APIPaymentInvoice = BASE_URL+"/api/payment/invoice";

// Reminder APIs
export const APIReminderRuleList = BASE_URL+"/api/reminder/rule/list";
export const APIReminderRuleStore = BASE_URL+"/api/reminder/rule/store";
export const APIReminderRuleUpdate = BASE_URL+"/api/reminder/rule/update";
export const APIReminderRuleDelete = BASE_URL+"/api/reminder/rule/delete";
export const APIReminderLogList = BASE_URL+"/api/reminder/log/list";
export const APIReminderLogExportExcel = BASE_URL+"/api/reminder/log/export-excel";
export const APIReminderLogExportPDF = BASE_URL+"/api/reminder/log/export-pdf";
export const APIReminderLogPrint = BASE_URL+"/api/reminder/log/print";
export const APIReminderStats = BASE_URL+"/api/reminder/stats";
export const APIReminderSendNow = BASE_URL+"/api/reminder/send-now";
export const APIReminderTestSend = BASE_URL+"/api/reminder/test-send";
export const APIReminderRunCron = BASE_URL+"/api/reminder/run-cron";

// Payment Receipt APIs
export const APIPaymentReceiptList = BASE_URL+"/api/payment-receipt/list";
export const APIPaymentReceiptStore = BASE_URL+"/api/payment-receipt/store";
export const APIPaymentReceiptDownload = BASE_URL+"/api/payment-receipt/download";
export const APIPaymentReceiptExportExcel = BASE_URL+"/api/payment-receipt/export-excel";
export const APIPaymentReceiptExportPDF = BASE_URL+"/api/payment-receipt/export-pdf";
export const APIPaymentReceiptPrint = BASE_URL+"/api/payment-receipt/print";
export const APIPaymentReceiptStats = BASE_URL+"/api/payment-receipt/stats";
export const APIPaymentReceiptBulkEmail = BASE_URL+"/api/payment-receipt/bulk-email";

// Tenant Ledger APIs
export const APITenantLedgerList = BASE_URL+"/api/tenant-ledger/list";
export const APITenantLedgerEntryStore = BASE_URL+"/api/tenant-ledger/entry/store";
export const APITenantLedgerEntryUpdate = BASE_URL+"/api/tenant-ledger/entry/update";
export const APITenantLedgerEntryDelete = BASE_URL+"/api/tenant-ledger/entry/delete";
export const APITenantLedgerExportExcel = BASE_URL+"/api/tenant-ledger/export-excel";
export const APITenantLedgerExportPDF = BASE_URL+"/api/tenant-ledger/export-pdf";
export const APITenantLedgerPrint = BASE_URL+"/api/tenant-ledger/print";
export const APITenantLedgerStats = BASE_URL+"/api/tenant-ledger/stats";
export const APITenantLedgerRecalculate = BASE_URL+"/api/tenant-ledger/recalculate";
export const APITenantLedgerVerify = BASE_URL+"/api/tenant-ledger/verify";
export const APITenantLedgerBalance = BASE_URL+"/api/tenant-ledger/balance";

// Vacancy Management APIs
export const APIVacancyList = BASE_URL+"/api/vacancy/list";
export const APIVacancyStore = BASE_URL+"/api/vacancy/store";
export const APIVacancyUpdate = BASE_URL+"/api/vacancy/update";
export const APIVacancyDelete = BASE_URL+"/api/vacancy/delete";
export const APIVacancyExportExcel = BASE_URL+"/api/vacancy/export-excel";
export const APIVacancyExportPDF = BASE_URL+"/api/vacancy/export-pdf";
export const APIVacancyPrint = BASE_URL+"/api/vacancy/print";
export const APIVacancyStats = BASE_URL+"/api/vacancy/stats";
export const APIVacancyMarkReady = BASE_URL+"/api/vacancy/mark-ready";
export const APIVacancyUpdateStatus = BASE_URL+"/api/vacancy/update-status";
export const APIVacancyBulkCreate = BASE_URL+"/api/vacancy/bulk-create";

// Maintenance Request APIs
export const APIMaintenanceRequestList = BASE_URL+"/api/maintenance-request/list";
export const APIMaintenanceRequestStore = BASE_URL+"/api/maintenance-request/store";
export const APIMaintenanceRequestUpdate = BASE_URL+"/api/maintenance-request/update";
export const APIMaintenanceRequestDelete = BASE_URL+"/api/maintenance-request/delete";
export const APIMaintenanceRequestExportExcel = BASE_URL+"/api/maintenance-request/export-excel";
export const APIMaintenanceRequestExportPDF = BASE_URL+"/api/maintenance-request/export-pdf";
export const APIMaintenanceRequestPrint = BASE_URL+"/api/maintenance-request/print";
export const APIMaintenanceRequestStats = BASE_URL+"/api/maintenance-request/stats";
export const APIMaintenanceRequestUpdateStatus = BASE_URL+"/api/maintenance-request/update-status";
export const APIMaintenanceRequestAssign = BASE_URL+"/api/maintenance-request/assign";
export const APIMaintenanceRequestComplete = BASE_URL+"/api/maintenance-request/complete";
export const APIMaintenanceRequestDeductFromRent = BASE_URL+"/api/maintenance-request/deduct-from-rent";
export const APIMaintenanceRequestUploadPhoto = BASE_URL+"/api/maintenance-request/upload-photo";


// Security Deposit Tracking APIs
export const APISecurityDepositList = BASE_URL+"/api/security-deposit/list";
export const APISecurityDepositStore = BASE_URL+"/api/security-deposit/store";
export const APISecurityDepositUpdate = BASE_URL+"/api/security-deposit/update";
export const APISecurityDepositDelete = BASE_URL+"/api/security-deposit/delete";
export const APISecurityDepositExportExcel = BASE_URL+"/api/security-deposit/export-excel";
export const APISecurityDepositExportPDF = BASE_URL+"/api/security-deposit/export-pdf";
export const APISecurityDepositPrint = BASE_URL+"/api/security-deposit/print";
export const APISecurityDepositStats = BASE_URL+"/api/security-deposit/stats";
export const APISecurityDepositDeduct = BASE_URL+"/api/security-deposit/deduct";
export const APISecurityDepositRefund = BASE_URL+"/api/security-deposit/refund";
export const APISecurityDepositForfeit = BASE_URL+"/api/security-deposit/forfeit";
export const APISecurityDepositHistory = BASE_URL+"/api/security-deposit/history";

// Move-Out Checklist APIs
export const APIMoveOutList = BASE_URL+"/api/move-out/list";
export const APIMoveOutStore = BASE_URL+"/api/move-out/store";
export const APIMoveOutUpdate = BASE_URL+"/api/move-out/update";
export const APIMoveOutDelete = BASE_URL+"/api/move-out/delete";
export const APIMoveOutExportExcel = BASE_URL+"/api/move-out/export-excel";
export const APIMoveOutExportPDF = BASE_URL+"/api/move-out/export-pdf";
export const APIMoveOutPrint = BASE_URL+"/api/move-out/print";
export const APIMoveOutStats = BASE_URL+"/api/move-out/stats";
export const APIMoveOutInspection = BASE_URL+"/api/move-out/inspection";
export const APIMoveOutGenerateStatement = BASE_URL+"/api/move-out/generate-statement";
export const APIMoveOutClose = BASE_URL+"/api/move-out/close";
export const APIMoveOutCalculate = BASE_URL+"/api/move-out/calculate";

// Expense Category APIs
export const APIExpenseCategoryList = BASE_URL+"/api/expense-category/list";
export const APIExpenseCategoryStore = BASE_URL+"/api/expense-category/store";
export const APIExpenseCategoryUpdate = BASE_URL+"/api/expense-category/update";
export const APIExpenseCategoryDelete = BASE_URL+"/api/expense-category/delete";
export const APIExpenseCategoryExportExcel = BASE_URL+"/api/expense-category/export-excel";
export const APIExpenseCategoryExportPDF = BASE_URL+"/api/expense-category/export-pdf";
export const APIExpenseCategoryPrint = BASE_URL+"/api/expense-category/print";

// Expense APIs
export const APIExpenseList = BASE_URL+"/api/expense/list";
export const APIExpenseStore = BASE_URL+"/api/expense/store";
export const APIExpenseUpdate = BASE_URL+"/api/expense/update";
export const APIExpenseDelete = BASE_URL+"/api/expense/delete";
export const APIExpenseExportExcel = BASE_URL+"/api/expense/export-excel";
export const APIExpenseExportPDF = BASE_URL+"/api/expense/export-pdf";
export const APIExpensePrint = BASE_URL+"/api/expense/print";
export const APIExpenseStats = BASE_URL+"/api/expense/stats";
export const APIExpenseApprove = BASE_URL+"/api/expense/approve";
export const APIExpenseReject = BASE_URL+"/api/expense/reject";
export const APIExpenseUploadReceipt = BASE_URL+"/api/expense/upload-receipt";

// Rent Collection Report APIs
export const APIRentCollectionReport = BASE_URL+"/api/reports/rent-collection";
export const APIRentCollectionExportExcel = BASE_URL+"/api/reports/rent-collection/export-excel";
export const APIRentCollectionExportPDF = BASE_URL+"/api/reports/rent-collection/export-pdf";
export const APIRentCollectionPrint = BASE_URL+"/api/reports/rent-collection/print";
export const APIRentCollectionStats = BASE_URL+"/api/reports/rent-collection/stats";

// Alerts/Reminders APIs
export const APIAlertList = BASE_URL+"/api/alert/list";
export const APIAlertDismiss = BASE_URL+"/api/alert/dismiss";
export const APIAlertDismissAll = BASE_URL+"/api/alert/dismiss-all";
export const APIAlertTakeAction = BASE_URL+"/api/alert/take-action";
export const APIAlertStats = BASE_URL+"/api/alert/stats";
export const APIAlertGenerate = BASE_URL+"/api/alert/generate";
export const APIAlertMarkRead = BASE_URL+"/api/alert/mark-read";
export const APIAlertExportExcel = BASE_URL+"/api/alert/export-excel";
export const APIAlertExportPDF = BASE_URL+"/api/alert/export-pdf";